import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const getPageKey = (pathname) => {
    if (pathname === '/' || pathname === '/home') return 'home';
    if (pathname.startsWith('/blog-details/')) return 'publication';
    const routeMap = {
        '/about': 'about',
        '/events': 'events',
        '/announcements': 'announcements',
        '/blog': 'blog',
        '/files': 'files',
        '/donation-listing': 'support',
        '/contact': 'contact',
        '/privacy': 'privacy',
    };
    return routeMap[pathname] || 'not_found';
};

const RouteMeta = () => {
    const { pathname } = useLocation();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const pageKey = getPageKey(pathname);
        const title = t(`meta.${pageKey}.title`);
        const description = t(`meta.${pageKey}.description`);
        let descriptionTag = document.querySelector('meta[name="description"]');

        document.title = title;
        document.documentElement.lang = (i18n.resolvedLanguage || i18n.language || 'tr').split('-')[0];

        if (!descriptionTag) {
            descriptionTag = document.createElement('meta');
            descriptionTag.name = 'description';
            document.head.appendChild(descriptionTag);
        }
        descriptionTag.content = description;
    }, [pathname, t, i18n.language, i18n.resolvedLanguage]);

    return null;
};

export default RouteMeta;
